import { ConfirmCancelReservationModalProps } from '../../../../components/ConfirmCancelReservationModal'
import { ReservationInfo } from '../../../../types/modifyReserveTAPanel'

/** What the confirmation modal shows for a modify quote. */
export const modifyQuoteModalData = (
  info: ReservationInfo
): ConfirmCancelReservationModalProps['data'] => ({
  currency: info.currency,
  payedPrice: info.originalAmount,
  currentPrice: info.currentAmount,
  penalty: info.penalty,
  payBack: info.originalAmount - info.penalty - info.currentAmount,
  promotionDropped: info.promotionDropped
})
